import { Component, OnInit, ViewChild } from '@angular/core';
import { BusinessProcessService } from '../../../services/business-process.service';
import { BusinessProcess } from '../../../Models/businessProcess';
import { ReportsFilterComponent, ReportFilterType } from '../../../common/reports-filter/reports-filter.component';
import { InstanceHistoryResultComponent } from '../../../common/reports-filter/instance-history-result/instance-history-result.component';
import { BehaviorSubject } from 'rxjs';
import {ReviewInstanceService} from '../../../services/review-instance.service';
import {Utils} from '../../../services/utils';
import {ConsolidationModalComponent} from '../../Runtime/business-process/consolidation-modal/consolidation-modal.component';
import {take} from 'rxjs/operators';
import {GenericModalService} from '../../../services/generic-modal.service';
import {ReviewModalComponent} from './review-modal/review-modal.component';
import {WebClientConfigurationService} from '../../../services/configuration/web-client-configuration.service';
import {PaginationInstance} from 'ngx-pagination';

@Component({
  selector: 'app-review-instances',
  templateUrl: './review-instances.component.html',
  styleUrls: ['./review-instances.component.css']
})
export class ReviewInstancesComponent implements OnInit {

  availableBusinessProcess: BusinessProcess[];
  filter: any;
  config: PaginationInstance;
  filterCollapse$: BehaviorSubject<boolean>;
  errorMessage = '';
  pleaseWait = false;
  data: any = {};
  utilsFunctions = Utils;
  hadSearched: boolean;
  p = 1;
  total: number;

  @ViewChild('reportsFilterComponent', {static: false}) reportsFilterComponent: ReportsFilterComponent;

  constructor(
    private bpService: BusinessProcessService,
    private reviewInstanceService: ReviewInstanceService,
    private webClientConfig: WebClientConfigurationService,
    private modalService: GenericModalService) {  }

  ngOnInit() {
    this.loadBusinessProcessList();
    this.filterCollapse$ = new BehaviorSubject(false);
  }

  loadBusinessProcessList() {
    this.errorMessage = '';
    this.bpService.getAllBusinessProcessesPublished()
      .subscribe(
        result => {
          this.availableBusinessProcess = result;
        }, error1 => this.errorMessage = error1
      );
  }

  getFilter(filter) {
    this.filter = filter;
    this.filterCollapse$.next(true);
    this.pleaseWait = true;
    this.search(1);
  }

  search(page: number) {
    this.filter.pageIndex = page;
    const reviewFilter = {
      businessProcessInstanceId: this.filter.businessProcessInstanceId,
      businessProcessId: this.filter.businessProcessInstanceId ? null : this.filter.businessProcessId,
      stateId: this.filter.businessProcessInstanceId ? null : this.filter.stateId,
      dateRange: this.filter.businessProcessInstanceId ? null : this.filter.dateRange,
      hasReview: this.filter.businessProcessInstanceId ? null : this.filter.hasReview,
      reviewDateRange: this.filter.businessProcessInstanceId ? null : this.filter.reviewDateRange,
      pageIndex: this.filter.pageIndex
    };
  this.data = {};
    this.reviewInstanceService.getReviewableInstances(reviewFilter).subscribe(
      result => {
        this.data =  result;
        this.total = result.totalReviewableInstances;
        this.p = 1;
        this.getPaginationConfig(page, this.total);
        this.pleaseWait = false;
        this.hadSearched = true;
      }, error1 => {
         this.errorMessage = error1;
         this.pleaseWait = false;
        this.hadSearched = true;
      }
    );
  }
  getPaginationConfig(_currentPage: number, _totalItems: number) {
    this.webClientConfig.getPageSizeConfig()
      .subscribe(item => {
        this.config  = {
          id: 'server',
          itemsPerPage: item,
          currentPage: _currentPage,
          totalItems: _totalItems
        };
      }, error1 => this.errorMessage = error1);
  }

  protected readonly ReportFilterType = ReportFilterType;

  openReviewInstanceWindow(interactionContextId: number) {
    this.bpService.openWindowReviewInstance(interactionContextId);
  }

  getInstanceReview(instanceId: number, instanceReviewId: number) {
    const destComponent: any = ReviewModalComponent;
    this.reviewInstanceService.getInstanceReview(instanceReviewId).subscribe(
      result => {
        this.pleaseWait = false;
        destComponent.data = result;
        this.modalService.showObjModal(destComponent, 'Parecer da instância ' + instanceId, result);
      }, error1 => {
        this.errorMessage = error1;
        this.pleaseWait = false;
      }
    );
  }
}
